export default "__VITE_ASSET__CSQVso0o__"